var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.loaded)?_c('AppMapMouseEditor',{attrs:{"readonly":"","screenOffset":"170px","minHeight":"","type":"polygon","mapStyle":"","withSearch":""},on:{"map-ready":_setup.saveMapInstance}}):_c('div',[_c(_setup.SspEmptyCard,{attrs:{"title":"暂无任务节点轨迹"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }